import $ from "jquery";
require("jquery-easing");


export default class Anchor {
  constructor() {}

  init() {
    this.handleHasnChange();

    window.onhashchange = () => {
      this.handleHasnChange();
    };

    $("#js-top-anchor-button").click((e) => {
      e.preventDefault();

      $("body,html").stop().animate({
        scrollTop: 0
      }, 1000, "easeInOutCubic");
    });

    $(".js-anchor-button").click(() => {
      // e.preventDefault();
      setTimeout(() => {
        this.handleHasnChange();
      }, 60);
    });
  }

  setAnchorSmoothScroll(name) {
    if (name.length <= 0) {
      return;
    }

    const id = "#js-anchor-" + name;
    const $target = $(id);
    const position = $target.offset().top - 100;
    const speed = Math.abs(position - $(window).scrollTop()) * 0.5;

    $("body,html").stop().animate({
      scrollTop: position
    }, speed, "easeInOutCubic");
  }

  handleHasnChange() {
    const hash = location.hash.length <= 0 ? null : location.hash;

    if (hash) {
      this.setAnchorSmoothScroll(hash.replace("#", ""));
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Anchor.js